<template>
  <div class="social">
    <a v-if="website" :href="website" target="_blank" class="easy"><icon name="laptop" :scale="scale"></icon></a>
    <a v-if="twitter" :href="twitter" target="_blank" class="easy"><icon name="twitter" :scale="scale"></icon></a>
    <a v-if="github" :href="github" target="_blank" class="easy"><icon name="github" :scale="scale"></icon></a>
    <a v-if="instagram" :href="instagram" target="_blank" class="easy"><icon name="instagram" :scale="scale"></icon></a>
    <a v-if="linkedin" :href="linkedin" target="_blank" class="easy"><icon name="linkedin" :scale="scale"></icon></a>
    <a v-if="googlePlus" :href="googlePlus" target="_blank" class="easy"><icon name="google-plus" :scale="scale"></icon></a>
    <a v-if="facebook" :href="facebook" target="_blank" class="easy"><icon name="facebook" :scale="scale"></icon></a>
  </div>
</template>

<script>
export default {
  name: 'social-icons',
  props: {
    scale: {
      type: Number,
      default: 1
    },
    website: {
      type: String
    },
    twitter: {
      type: String
    },
    github: {
      type: String
    },
    instagram: {
      type: String
    },
    linkedin: {
      type: String
    },
    googlePlus: {
      type: String
    },
    facebook: {
      type: String
    }
  },
  data () {
    return {
    }
  }
}
</script>

<style lang="sass">
  @import ../assets/styles/scss/variables.scss

  .social > a
    text-decoration: none
    color: $grey
    margin-right: 15px
    font-size: 1.5em

    &:last-of-type
      margin-right: 0

    &:hover
      color: $lightGrey
  
</style>



// WEBPACK FOOTER //
// SocialIcons.vue?be4c94ec